export default __webpack_public_path__ + "static/media/greeting3.b6639b8c.svg";